
import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SeedOilData } from "../../models/oilProduction-model";

interface Props {
  seedOilData: SeedOilData[];
}

const SeedOilDataTable: React.FC<Props> = ({ seedOilData }) => {
const formatValue = (rowData: SeedOilData, field: keyof SeedOilData) => {
  if (rowData.seedName === "Total" || rowData.seedName === "No Prod") {
    const value = rowData[field];

    if (value === 0 || value === "0.000000%") {
      return "";
    }
  }

  return rowData[field];
};


  return (
    <>
     <div className="col-12 card border-noround p-3">
    <DataTable
    value={seedOilData.filter((item) => item.seedName !== "Available Capacity")}
      // value={seedOilData}
      stripedRows
      showGridlines
      responsiveLayout="scroll"
      emptyMessage="No data available"
    //   rowClassName={rowClassName}
    >

  <Column
    field="seedName"
    header="Seed Name"
    body={(rowData) => rowData.seedName}
    bodyClassName={(rowData) => {
      if (rowData.seedName === "Total") return "bg-blue-100 font-bold";
      if (rowData.seedName === "No Prod") return "bg-red-100 text-red-700 font-semibold";
      return "";
    }}
  />
  <Column
    field="noOfBatches"
    header="No. of Batches"
    body={(rowData) => rowData.noOfBatches}
    bodyClassName={(rowData) => {
      if (rowData.seedName === "Total") return "bg-blue-100 font-bold";
      if (rowData.seedName === "No Prod") return "bg-red-100 text-red-700 font-semibold";
      return "";
    }}
  />
    <Column
    field="oilInLtr"
    header="Oil in Ltr"
     body={(rowData) => formatValue(rowData, "oilInLtr")} 
    bodyClassName={(rowData) => {
      if (rowData.seedName === "Total") return "bg-blue-100 font-bold";
      
      return "";
    }}
  />
      {/* <Column field="oilInLtr" header="Oil in Ltr" body={(rowData) => formatValue(rowData, "oilInLtr")} /> */}
<Column field="percentage" header="Total %" body={(rowData) => formatValue(rowData, "percentage")} />
<Column field="seedsCrushedInKgs" header="Seeds Crushed in Kgs" body={(rowData) => formatValue(rowData, "seedsCrushedInKgs")} />
<Column field="averageYield" header="Average Yield" body={(rowData) => formatValue(rowData, "averageYield")} />
<Column field="cakesWeight" header="Cakes Weight" body={(rowData) => formatValue(rowData, "cakesWeight")} />

    </DataTable>
    </div>
    </>
  );
};

export default SeedOilDataTable;
